import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { REGEX } from '../constants/regex.constants';

export function leadingOrTrailingWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value;

    if (!value) {
      return null;
    }

    const hasWhitespace = REGEX.leadingOrTrailingWhitespace.test(value);

    return hasWhitespace ? { leadingOrTrailingWhitespace: true } : null;
  };
}
